module.exports = __webpack_public_path__ + "img/7.11ebb12a.png";